/**
 * Access check from localStorage (for use in router guards where $access is not available).
 * Mirrors the logic in mixin.vue $access() so route guards and sidebar stay in sync.
 * Uses role for current house (house_roles) when available so the same user can have different roles per house.
 */
export function hasAccess(moduleName, action) {
  try {
    const raw = localStorage.getItem("ipms_admin");
    if (!raw) return false;
    const admin = JSON.parse(raw);
    if (admin.is_owner === 1 || admin.is_owner === true) return true;
    if (admin.type === "sadmin") return true;
    // Org admins can access Dashboard (property view) when they select a house
    if (admin.type === "admin") return true;
    let role = admin.role;
    const houseId = (() => {
      try {
        const h = localStorage.getItem("ipms_house");
        if (!h || h === "undefined") return null;
        return JSON.parse(h)?.house_id ?? null;
      } catch {
        return null;
      }
    })();
    if (houseId && admin.house_roles && Array.isArray(admin.house_roles)) {
      const forHouse = admin.house_roles.find((hr) => hr.house_id === houseId);
      if (forHouse && forHouse.role) role = forHouse.role;
    }
    const permissions = role?.permissions;
    if (!permissions) return false;
    const list =
      typeof permissions === "string" ? JSON.parse(permissions) : permissions;
    if (!Array.isArray(list)) return false;
    const perm = list.find((p) => p.name === moduleName);
    if (!perm) return false;
    const values = perm.values;
    if (Array.isArray(values)) return values.includes(action);
    return values === action;
  } catch {
    return false;
  }
}
